import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseUrls } from '@app/app.constants';
import { PhoneBookContact } from '@app/core/interfaces/c5/phone-book-contact';
import { UserLevel } from '@app/core/models/user-level';
import { Upload, UploadService } from '@app/shared/services/upload.service';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { PhoneBookImportItem } from '@business/phone-book/models/phone-book-import-view-model';
import { PhoneBookModel } from '@business/phone-book/models/phone-book-model';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PhoneBookRepository {
  constructor(
    private http: HttpClient,
    private uploadService: UploadService,
    private utils: Utils
  ) {}

  create(contact: PhoneBookContact): Observable<void> {
    return this.utils.apiUrl(`/phonebook`).pipe(
      mergeMap((url) => this.http.post<void>(url, contact)),
      wrapError('phone-book-repository:create')
    );
  }

  delete(id: number): Observable<void> {
    return this.utils.apiUrl(`/phonebook/${id}`).pipe(
      mergeMap((url) => this.http.delete<void>(url)),
      wrapError('phone-book-repository:delete')
    );
  }

  importContacts(file: File, replaceOld: boolean = false): Observable<Upload<PhoneBookImportItem[]>> {
    return this.utils.apiUrl(`/phonebookImport`).pipe(
      mergeMap((url) => {
        if (replaceOld === true) {
          url = url + '?replaceOld=true';
        }
        return this.uploadService.post<PhoneBookImportItem[]>({
          url,
          file,
        });
      }),
      wrapError('phone-book-repository:import-contacts')
    );
  }

  list(): Observable<PhoneBookContact[]> {
    return this.utils
      .apiUrl({
        [UserLevel.ServiceProviderAdmin]: BaseUrls.ServiceProvider.Enterprise + '/phonebook',
        [UserLevel.EnterpriseAdmin]: BaseUrls.Enterprise.Enterprise + '/phonebook',
        [UserLevel.EndUser]: BaseUrls.EndUser + '/phonebook',
      })
      .pipe(
        mergeMap((url) => this.http.get<PhoneBookContact[]>(url)),
        wrapError('phone-book-repository:list')
      );
  }

  phoneBookDownloadUrl(): Observable<string> {
    return this.utils.apiUrl(`/phonebookExport`);
  }

  phoneBookTemplateDownloadUrl(): Observable<string> {
    return this.utils.apiUrl(`/phonebookTemplateExport`);
  }

  update(phoneBook: PhoneBookModel): Observable<void> {
    return this.utils.apiUrl(`/phonebook/${phoneBook.id}`).pipe(
      mergeMap((url) => this.http.put<void>(url, phoneBook)),
      wrapError('phone-book-repository:update')
    );
  }
}
